<template>
  <div class="col-auto">
    <model-table
      :collection="deliveryTypes"
      :columns="[
        { field: 'id' },
        { field: 'name' },
        { field: 'description' },
        { field: 'enable', component: 'checkbox' },
        { field: 'availableOnline', component: 'checkbox' },
        { label: 'Collect Details', field: 'hasDetails', component: 'checkbox' },
        { name: 'actions', align: 'right' }
      ]"
      orderable
    >
      <delivery-type-form />
    </model-table>
  </div>
</template>

<script>

import ModelTable from 'src/modules/admin/components/ModelTable'
import DeliveryTypeForm from 'src/modules/admin/delivery-type/DeliveryTypeForm'

export default {
  name: 'DeliveryTypeTable',
  components: {
    ModelTable,
    DeliveryTypeForm
  },
  models: {
    deliveryTypes: 'default'
  }
}

</script>
